module.exports = __webpack_public_path__ + "img/home_bg_02_1.0c02bcbb.jpg";